var config = require('../modules/Config/Config'),
    tracker = require('./tracker');

// Make sure that there are analytics accounts set up for this environment
// before loading in Google Analytics
if (config.googleAnalytics && config.googleAnalytics.length > 0) {
  module.exports = tracker({
    name: 'Google Analytics',
    conf: config.googleAnalytics,
    library: function libFn() {

      // Load the Google Analytics library
      (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments)
          }, i[r].l = 1 * new Date();
        a = s.createElement(o),
          m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m && m.parentNode.insertBefore(a, m)
      })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
    },
    initialize: function initFn(trackingOptions) {

      // Define a container for options that will be passed to Google
      var gaOptions = {};

      // Extract the name option if it exists
      if (trackingOptions.name) {
        gaOptions['name'] = trackingOptions.name;
      }

      // Initialize the tracking code with Google Analytics
      ga('create', trackingOptions.key, 'auto', gaOptions);

      // If specified, load additional analytics plugins. A tracker name must have been specified.
      if (gaOptions['name'] && trackingOptions['plugins']) {
        for (var p in trackingOptions.plugins) {
          ga(gaOptions['name'] + '.require', trackingOptions.plugins[p]);
        }
      }
    },
    track: function trackFn(trackId, trackingArgs, trackingConf) {

      // If this tracker has a name value specified then prepend it to the
      // command to specify the tracker
      if (trackingConf.name) {
        trackingArgs[0] = trackingConf.name + '.' + trackingArgs[0];
      }

      // Finally call the underlying Google Analytics function to track
      window.ga.apply(window, trackingArgs);
    },
    filter: function filterFn(confFilter, trackingArgs) {
      return trackingArgs &&
        trackingArgs.length > 1 &&
        confFilter &&
        confFilter.length > 0 &&
        confFilter.indexOf(trackingArgs[1]) !== -1;
    }
  });
} else {

  // If there is no Google Analytics configuration, export a NoOp
  module.exports = function() {};
}


//////////////////
// WEBPACK FOOTER
// ./htdocs/content/themes/tpt-national/assets/js/vendor/google-analytics.js
// module id = 14
// module chunks = 0 1